import httpClient from '../httpService';
import { DmPhongHoc } from './PhongHocModels';

const PhongHocApiUrl = '/api/phongHoc/';
export const PhongHocService = {
    getAll: (): Promise<DmPhongHoc[]> => {
        return httpClient
            .get(PhongHocApiUrl + 'GetAll')
            .then((res) => res.data.data)
            .catch((err) => {
                console.error('Lỗi lấy dữ liệu phòng học: ' + err);
                return [];
            });
    },

    getById: (id_phong: number): Promise<DmPhongHoc> => {
        return httpClient
            .get(PhongHocApiUrl + 'GetByID', { params: { id: id_phong } })
            .then((res) => res.data.data)
            .catch((err) => {
                console.error('Lỗi lấy phòng học theo ID: ' + err);
                throw err;
            });
    }
};
